import { AccountOption, IAccountsByCustomer } from 'src/app/interfaces/self-serve/iaccounts-by-customer';
import { ICustomerAccountPayload } from 'src/app/interfaces/reportingV2/icustomer-account-payload';
import { EntityOption } from '../interfaces/reportingV2/ientity-option';

export class AccountEntityUtil {
  private static readonly ALL_VALUE = 'all';

  static formatAccounts(accountsByCustomer: IAccountsByCustomer[]): AccountOption[] {
    const allAccounts = accountsByCustomer.flatMap(customer => customer.accounts);
    return allAccounts.map(account => ({
      label: account.accountName,
      value: account.accountUuid,
    }));
  }

  static formatEntities(entities: { name: string; uuid: string }[]): EntityOption[] {
    const entityOptions = entities
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(entity => ({
        label: entity.name,
        value: entity.uuid,
      }));

    return [...entityOptions];
  }


  static getAllEntityValues(entityOptions: EntityOption[]): string[] {
    return entityOptions
      .filter(entity => entity.value !== this.ALL_VALUE)
      .map(entity => entity.value);
  }


  static createCustomerAccountPayload(multiCustomerAccount: IAccountsByCustomer[], unknownCustomerLabel = 'Unknown Customer'): ICustomerAccountPayload[] {
    if (!multiCustomerAccount || multiCustomerAccount.length === 0) {
      return [];
    }

    return multiCustomerAccount.map(customer => ({
      customerName: customer.customerName || unknownCustomerLabel,
      accountInfos: customer.accounts?.map(account => ({
        accountUuid: account.accountUuid,
        accountName: account.accountName
      })) || []
    }));
  }

  static findAccountByUuid(accountOptions: AccountOption[], accountUuid: string): AccountOption | null {
    if (!accountOptions) {
      return null;
    }
    return accountOptions.find(acc => acc.value === accountUuid) || null;
  }

  static getDefaultSelectedAccount(accountOptions: AccountOption[], storedAccountUuid?: string | null): AccountOption | null {
    if (accountOptions.length === 0) {
      return null;
    }
    if (storedAccountUuid) {
      const found = this.findAccountByUuid(accountOptions, storedAccountUuid);
      return found ?? accountOptions[0];
    }
    return accountOptions[0];
  }
  static getDefaultSelectedEntities(
    entityOptions: EntityOption[],
    storedEntities?: string[] | string | null
  ): string[] | string {
    if (entityOptions.length === 0) {
      return [];
    }

    if (storedEntities && storedEntities.length > 0) {
      return storedEntities;
    }

    return [this.ALL_VALUE, ...this.getAllEntityValues(entityOptions)];
  }
}
